var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//libs
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { TextField } from '@swiggy-private/dls-web-core/dist/components/TextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
import AsyncButton from '@/widgets/AsyncButton/AsyncButton';
// widgets
import { AccountsList } from './widgets/AccountsList';
// utils
import { format } from '@/helpers/utils';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import Routes from '@/constants/Routes';
import { NULL } from '@/constants/Misc';
// includes
import { listAccountsApi } from '@/includes/api/account/list';
import { getPermissionsApi } from '@/includes/api/account/permissions';
import { getAccountApi } from '@/includes/api/account/get';
// styles
import styles from './AccountSelect.module.scss';
// stores
import useAccountStore from '@/stores/account';
const TEXT = {
    header: 'Welcome to Swiggy Ads Dashboard',
    subHeader: 'Welcome {0}, Kindly choose an account to create a new campaign or view campaign details',
    noAccountSubHeader: 'Welcome {0}, You have not been added to any brand account, please contact your administrator or reach out to your Swiggy account manager.',
};
const AccountSelectPage = () => {
    var _a, _b;
    const { accounts, user, loggedInAccountDetails, setAccounts, setLoggedInAccountDetails, } = useAccountStore((state) => ({
        accounts: state.accounts,
        user: state.user,
        loggedInAccountDetails: state.loggedInAccountDetails,
        setAccounts: state.setAccounts,
        setLoggedInAccountDetails: state.setLoggedInAccountDetails,
    }));
    const [accountIdAdminInput, setAccountIdAdminInput] = useState('');
    const [fetchingInputAccount, setFetchingInputAccount] = useState(false);
    useEffect(() => {
        !accounts.length && fetchAccounts();
    }, []);
    const navigate = useNavigate();
    const fetchAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
        const { accounts } = yield listAccountsApi();
        accounts.length && setAccounts(accounts);
    });
    const handleAccountChange = (account) => __awaiter(void 0, void 0, void 0, function* () {
        const { isAdmin, permissions } = yield getPermissionsApi({
            accountId: account.accountId,
        });
        setLoggedInAccountDetails({ account, isAdmin, permissions });
        navigate(Routes.INSTAMART_HOME, { preventScrollReset: true });
    });
    const handleInputAccountIdLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!loggedInAccountDetails.isAdmin || !accountIdAdminInput) {
            return;
        }
        setFetchingInputAccount(true);
        const accountFound = accounts.find((account) => account.accountId === accountIdAdminInput);
        if (accountFound) {
            setLoggedInAccountDetails(Object.assign(Object.assign({}, loggedInAccountDetails), { account: accountFound }));
            navigate(Routes.INSTAMART_HOME, { preventScrollReset: true });
            return;
        }
        const { account } = yield getAccountApi({
            accountId: accountIdAdminInput,
        });
        setFetchingInputAccount(false);
        if (account) {
            setLoggedInAccountDetails(Object.assign(Object.assign({}, loggedInAccountDetails), { account }));
            navigate(Routes.INSTAMART_HOME, { preventScrollReset: true });
            return;
        }
        return;
        // TODO: handle if no account found
    });
    const handleAccountIdInputChange = (value) => {
        setAccountIdAdminInput(value);
    };
    const renderAccountInputBox = () => {
        return (React.createElement("div", { className: styles.accountInputWrapper },
            React.createElement("div", { className: styles.accountInputContainer },
                React.createElement(TextField, { textFieldDetails: {
                        containerStyle: {
                            width: '400px',
                        },
                        value: accountIdAdminInput,
                        isDisabled: fetchingInputAccount,
                        type: TextFieldTypes.TEXT,
                        name: 'manual-account-input',
                        label: 'Enter Account Id',
                        onChange: handleAccountIdInputChange,
                        attrs: { autoComplete: 'off' },
                    }, rightActionDetails: [
                        {
                            type: RightActionTypes.CLEAR,
                        },
                    ] }),
                React.createElement(AsyncButton, { variant: "primary", onClick: handleInputAccountIdLogin }, "Submit"))));
    };
    const subHeader = accounts.length === 0 && !loggedInAccountDetails.isAdmin
        ? format(TEXT.noAccountSubHeader, (_a = user === null || user === void 0 ? void 0 : user.email.split('@')[0]) !== null && _a !== void 0 ? _a : NULL)
        : format(TEXT.subHeader, (_b = user === null || user === void 0 ? void 0 : user.email.split('@')[0]) !== null && _b !== void 0 ? _b : NULL);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.description },
            React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis }, TEXT.header),
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_High_Emphasis }, subHeader)),
        loggedInAccountDetails.isAdmin && renderAccountInputBox(),
        React.createElement(AccountsList, { accounts: accounts, onAccountClick: handleAccountChange })));
};
export default AccountSelectPage;
